import { OnboardingShell } from "./OnboardingShell";

export function OnboardingDoctorsPage() {
  return (
    <OnboardingShell
      step={3}
      title="Bác sĩ"
      description="Thêm bác sĩ + chứng chỉ hành nghề. Bác sĩ sẽ xuất hiện trong dropdown đặt lịch hẹn."
      ctaTo="/settings/doctors"
      ctaLabel="Mở danh sách bác sĩ"
      backTo="/onboarding/services"
      nextTo="/onboarding/schedule"
    >
      <p className="text-sm text-muted-foreground">
        Mỗi bác sĩ cần một hồ sơ để nhận lịch hẹn và kê đơn.
      </p>
    </OnboardingShell>
  );
}
